import ReactModal from 'react-modal';
import React, { memo } from 'react';
import styles from './styles.module.scss';

const ProtectedAdModal = ({ show, onClose }) => (
  <ReactModal
    isOpen={show}
    shouldCloseOnOverlayClick
    contentLabel="Protected Ad Modal"
    className={`${styles['modal-dialog']}`}
    overlayClassName={`${styles.modal} ${styles['modal--after-open']} `}
    bodyOpenClassName={`${styles['modal-open']}`}
    onRequestClose={onClose}
    ariaHideApp={false}
  >
    <div className={`${styles['modal-content']} `}>
      <div className={styles['modal-body']}>
        <div
          className={`${styles.closeButtonProtectedModal}`}
          role="presentation"
          onClick={onClose}
        />
        <div className={`${styles.imageTitleProtectedModal}`}>
          <img
            className={`${styles.topIcEntitlement}`}
            src="https://static.chotot.com/storage/chotot-icons/svg/ic_protection_partner.svg"
            alt=" "
          />
        </div>
        <div className={`${styles.textTitleProtectedModal}`}>Đối Tác Việc Làm Tốt</div>
        <div className={`${styles.contentProtectedModal}`}>
          <div className={`${styles.contentItem}`}>
            <div className={`${styles.contentIcon}`}>
              <img
                src="https://static.chotot.com/storage/chotot-icons/svg/checkbox_selected.svg"
                alt=" "
              />
            </div>
            <div className={`${styles.contentText}`}>
              <span>Cam kết nội dung công việc và mức lương như tin đăng, không lừa đảo</span>
            </div>
          </div>
          <div className={`${styles.contentItem}`}>
            <div className={`${styles.contentIcon}`}>
              <img
                src="https://static.chotot.com/storage/chotot-icons/svg/checkbox_selected.svg"
                alt=" "
              />
            </div>
            <div className={`${styles.contentText}`}>
              <span>Cam kết phản hồi cho ứng viên trong 7 ngày sau khi nộp đơn</span>
            </div>
          </div>
          <div className={`${styles.contentItem}`}>
            <div className={`${styles.contentIcon}`}>
              <img
                src="https://static.chotot.com/storage/chotot-icons/svg/checkbox_selected.svg"
                alt=" "
              />
            </div>
            <div className={`${styles.contentText}`}>
              <span>Việc Làm Tốt hỗ trợ giải quyết khiếu nại khi có mâu thuẫn phát sinh</span>
            </div>
          </div>
        </div>
        <div className={`${styles.actionsProtectedModal}`}>
          <div className={`${styles.linkHelpPage}`}>
            <a
              href="https://trogiup.chotot.com/nguoi-ban/doi-tac-viec-lam-tot"
              target="_blank"
              rel="noreferrer"
            >
              Tìm hiểu thêm
            </a>
          </div>
          <div className={`${styles.buttonUnderstand}`}>
            <button type="button" onClick={onClose}>
              Đã hiểu
            </button>
          </div>
        </div>
      </div>
    </div>
  </ReactModal>
);

export default memo(ProtectedAdModal);
